<template>
  <div :class="colGrid">
    <div class="card card-estilo p-grid p-fluid" :class="getClass">
      <!-- <card-titulo :texto="titulo" :cor="cor" /> -->
      <h1 v-if="titulo" class="p-col-12">{{ titulo }}</h1>

      <div class="p-col-12" v-if="legendaObrigatorio">
        <label style="color: red"><span>*</span> Campos Obrigatórios</label>
      </div>

      <!-- Renderiza as tags filhas adicionadas ao componente -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
import gridCss from "../common/grid";

export default {
  name: "CardSeplag",
  props: {
    titulo: {
      // Especifica o titulo a ser exibido no cabeçalho da tabela
      type: String,
      default: null,
    },
    cor: {
      // Especifica o titulo a ser exibido no cabeçalho da tabela
      type: String,
    },
    cols: {
      // Especifica o titulo a ser exibido no cabeçalho da tabela
      type: String,
    },
    classe: {
      // Especifica o titulo a ser exibido no cabeçalho da tabela
      type: String,
    },
    legendaObrigatorio: {
      // Informa se tela deve exibido a legenda o * de obrigatoriedade , default=false
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colGrid() {
      return gridCss(this.cols ? this.cols : "12");
    },
    getClass() {
      return this.classe;
    },
  },
};
</script>

<style scoped>
.card-estilo {
  /* margin-top: 30px; */
  border-radius: 6px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
}

.card-estilo h1 {
  margin-bottom: 20px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>